require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./prog-soc-executive-team.json") })
        }
      }, "path---prog-soc-executive-team");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---prog-soc-executive-team!./.cache/json/prog-soc-executive-team.json
// module id = 387
// module chunks = 231608221292675